import * as React from 'react';

import { getEventBusIfDefined } from '@cian/event-bus';

// tslint:disable-next-line: match-default-export-name
import DropDownMenu, { IDropdownMenuLink } from './dropdown_menu';
import { TDropdownType } from './interfaces';

interface IDropdownMenuContainerState {
  hasShadow?: boolean;
  links: IDropdownMenuLink[];
  show: boolean;
  newbuildingConsultantPhone: string;
}

export interface IDropdownMenuContainerProps {
  name: TDropdownType;
  links: IDropdownMenuLink[];
  dealRentHeaderBannerEnabled: boolean;
}

export class DropdownMenuContainer extends React.Component<IDropdownMenuContainerProps, IDropdownMenuContainerState> {
  public state = {
    hasShadow: false,
    links: this.props.links,
    show: true,
    newbuildingConsultantPhone: '',
  };

  public componentDidMount() {
    const { name } = this.props;
    this.setState({
      hasShadow: window.___header_serpPageType !== name,
    });
    const eventBus = getEventBusIfDefined();

    if (eventBus) {
      eventBus.subscribe('header:category_changed', this.categoryChangedHandler);
      eventBus.subscribe('header:links_changed', this.chageUrlHandler);
      eventBus.subscribe('header:set_newbuilding_consultant_phone', this.setNewbuildingConsultantPhone);
    }
  }

  public render() {
    return (
      <DropDownMenu
        links={this.state.links}
        name={this.props.name}
        hasShadow={this.state.hasShadow}
        newbuildingConsultantPhone={this.state.newbuildingConsultantPhone}
      />
    );
  }

  private chageUrlHandler = (event: CianEventBus.IEvent) => {
    this.setState({ links: this.props.links });
  };

  private categoryChangedHandler = (event: CianEventBus.IEvent) => {
    const { type } = event;
    const { name } = this.props;
    this.setState({ hasShadow: type !== name });
  };

  private setNewbuildingConsultantPhone = (event: CianEventBus.IEvent) => {
    const { type } = event;
    this.setState({ newbuildingConsultantPhone: type });
  };
}
